<template>
  <div>
    <div v-for="question in questions" :key="question.id">
      <div class="question-title" v-html="question.label"></div>
      <div class="sentiments">
        <div v-for="(choice, index) in question.choices" :key="index">
          <input
            :id="`radio-${question.id}-${index}`"
            type="radio"
            v-model="question.response"
            :value="index"
            style="display: none"
            v-on:change="handleInputCompleted"
          />
          <label class="sentiment" :for="`radio-${question.id}-${index}`">
            <img :src="choice.icon" />
            <span class="sentiment-label">{{ choice.label }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TechTypesLikertScale3'
}
</script>
